module.exports = __webpack_public_path__ + "media/images/profile2-92984135cd3f4ef7816c2f87d957c2d7.png";